"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var DataObjectConverter_1 = require("../conversions/DataObjectConverter");

var JSONDataObjectConversions_1 = require("../conversions/JSONDataObjectConversions");

var index_1 = require("./index");

var ObjectUtils =
/*#__PURE__*/
function () {
  _createClass(ObjectUtils, null, [{
    key: "hashCode",

    /**
     * Returns string's hash-code by algorithm from https://gist.github.com/hyamamoto/fd435505d29ebfa3d9716fd2be8d42f0
     */
    value: function hashCode(s) {
      var h = 0;

      for (var i = 0; i < s.length; i++) {
        // tslint:disable-next-line
        h = Math.imul(31, h) + s.charCodeAt(i) | 0;
      }

      return h;
    }
    /**
     * Returns shallow copy of given object.
     * @param obj
     */

  }, {
    key: "clone",
    value: function clone(obj) {
      var target = {};
      Object.assign(target, obj);
      Object.setPrototypeOf(target, Object.getPrototypeOf(obj));
      return target;
    }
    /**
     * Check object for existence for selected parameter
     * @param ref
     * @param param
     * @param format
     */

  }, {
    key: "hasDefinedValue",
    value: function hasDefinedValue(ref, param, format) {
      if (!index_1.Utils.isObject(ref)) {
        throw new TypeError('Object expected: ' + typeof ref);
      }

      if (!ref.hasOwnProperty(param)) {
        throw new Error("Param is not defined: ".concat(param));
      }

      var v = ref[param];

      if (!index_1.Utils.isValueMissing(v) && format) {
        return format(v);
      }

      return v || null;
    }
    /**
     * Returns true if given objects are equal. Optionally with whitelist or blacklist of object properties.
     * If both lists are defined, property has to be whitelisted and also not blacklisted at the same time.
     * @param entityClass
     * @param t1
     * @param t2
     * @param whiteList
     * @param blackList
     */
    // TODO ZSt signature of this method, mutable ???

  }, {
    key: "equals",
    value: function equals(entityClass, t1, t2, whiteList, blackList) {
      if (t1 === null && t2 === null) {
        return true;
      }

      if (t1 !== null && t2 !== null) {
        var entityConverter = typescript_ioc_1.Container.get(DataObjectConverter_1.DataObjectConverter, {
          className: entityClass
        });
        var d1 = entityConverter.toDocument(t1, JSONDataObjectConversions_1.jsonConversions);
        var d2 = entityConverter.toDocument(t2, JSONDataObjectConversions_1.jsonConversions);

        if (whiteList || blackList) {
          var keys = Object.keys(d1);

          var _loop = function _loop() {
            var key = keys[_i];

            if (whiteList && whiteList.findIndex(function (v) {
              return v === key;
            }) === -1 || blackList && blackList.findIndex(function (v) {
              return v === key;
            }) !== -1) {
              delete d1[key];
              delete d2[key];
            }
          };

          for (var _i = 0; _i < keys.length; _i++) {
            _loop();
          }
        }

        return JSON.stringify(d1) === JSON.stringify(d2);
      }

      return false;
    }
    /**
     * Returns true if given BigNumbers are equal. Null, undefined and NaN values are considered as equal.
     * @param v1 first number
     * @param v2 second number
     * @param relativeThreshold
     * @param absoluteThreshold
     */

  }, {
    key: "equalsBigNumber",
    value: function equalsBigNumber(v1, v2, relativeThreshold, absoluteThreshold) {
      if (index_1.Utils.isValueMissing(v1) && index_1.Utils.isValueMissing(v2)) {
        return true;
      }

      if (v1 && v2) {
        if (v1.isNaN() && v2.isNaN()) {
          return true;
        }

        if (relativeThreshold || absoluteThreshold) {
          var diff = v2.minus(v1).abs();

          if (absoluteThreshold && diff.greaterThan(absoluteThreshold)) {
            return false;
          }

          if (relativeThreshold) {
            if (v1.isZero() && v2.isZero()) {
              return true;
            }

            if (v1.isZero() || v2.isZero()) {
              return false;
            }

            return diff.div(v1).abs().mul(100).lessThanOrEqualTo(relativeThreshold);
          }
        }

        return v1.eq(v2);
      }

      return false;
    }
    /**
     * Returns true if given BigNumbers are equal ( within given thresholds )
     * Null, undefined and NaN values are considered as equal.
     * I created this method because thresholds should not be evaluated when equals to zero ( and was
     * unable to update ObjectUtils.equalsBigNumber )
     *
     * 1. threshold is number > than zero = use threshold to determine equality
     * 2. threshold is zero = do not check equality
     * 3. threshold is undefined = check equality with zero tolerance
     *
     * @param v1 first number
     * @param v2 second number
     * @param relTh
     * @param absTh
     */

  }, {
    key: "compareBigNumbers",
    value: function compareBigNumbers(v1, v2, relTh, absTh) {
      // both thresholds are disabled, therefore values are considered equal
      if (relTh === 0 && absTh === 0) {
        return true;
      } // both values missing, therefore are equal


      if (index_1.Utils.isValueMissing(v1) && index_1.Utils.isValueMissing(v2)) {
        return true;
      }

      if (v1 && v2) {
        // both values are nan, therefore are equal
        if (v1.isNaN() && v2.isNaN()) {
          return true;
        }

        var diff = v2.minus(v1).abs();

        if (relTh !== undefined) {
          if (relTh > 0) {
            // zeros will result in math error
            if (v1.isZero() && v2.isZero()) {
              return true;
            }

            if (v1.isZero() || v2.isZero()) {
              return false;
            }

            return diff.div(v1).abs().mul(100).lessThanOrEqualTo(relTh);
          }
        }

        if (absTh !== undefined) {
          if (absTh > 0) {
            return !diff.greaterThan(absTh);
          }
        } // both thresholds are undefined, check equality with zero tolerance


        return !diff.gt(0);
      }

      return false;
    }
  }]);

  function ObjectUtils() {
    _classCallCheck(this, ObjectUtils);
  }

  return ObjectUtils;
}();

exports.ObjectUtils = ObjectUtils;